import { render, staticRenderFns } from "./DisclosureOfInformation.vue?vue&type=template&id=6010e632"
import script from "./DisclosureOfInformation.vue?vue&type=script&lang=ts"
export * from "./DisclosureOfInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports